import { createContext } from 'react';

const ReferencesContext = createContext(null);

export default ReferencesContext;
